

const state = {
    
    blocks:[
        {
            id:1,
            name: 'Preparations',
            color: '#fff',   
            columns:1,
            blockcomponents: {
                columns: [
                    //left Column
                    [
                        {
                            id:1,
                            name:'formdatatable',
                            attributes: {
                                placeholder:"Preparations",
                                size:"xs10",
                                invertedsize:"xs1",                                
                                icon:"search",                                
                                setter: 'preparations/PREPARATION_SET_PREPARATION',                                    
                                items:'preparations/preparations',
                                withcheck:false,
                                withsearch:true,
                                withdialog:false,
                                headers: [
                                    {
                                        text: 'Text',
                                        value: 'text',
                                        sortable:false
                                    },    
                                    
                                ]
                            }                                    
                        }
                    ],                   
                ]
            },
        },
        
    ]
    
};

export default {
  namespaced: false,
  state,
  
};